import { makeStyles } from '@material-ui/core/styles';
import { reskinStyles } from 'core/components/theme/theme-variant';

const styles = (theme) => ({
  warning: {
    display: 'flex',
    gap: theme.spacing(2),
    padding: theme.spacing(4),
    backgroundColor: theme.colorPalette.green_100,
    color: theme.onCard.white,
    ...reskinStyles(theme, { backgroundColor: theme.colorPalette.beige_25, borderRadius: theme.sizes.innerCorners })
  },
  icon: {
    width: 16,
    height: 16
  },
  header: {
    padding: theme.spacing(0),
    fontWeight: 600,
    fontSize: 14,
    lineHeight: '20px',
    color: theme.onCard.white
  },
  text: {
    fontWeight: 400,
    fontSize: 14,
    lineHeight: '20px',
    color: theme.onCard.white,
    padding: theme.spacing(1, 0)
  },
  extraBottomPadding: {
    paddingBottom: theme.spacing(2)
  }
});

export default makeStyles(styles);
